import "preline/preline";
import { type IStaticMethods } from "preline/preline";

declare global {
  interface Window {
    HSStaticMethods: IStaticMethods;
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  if (process.client) {
    import('preline/dist/preline.js');
    
    nuxtApp.hook("page:finish", () => {
      window.HSStaticMethods.autoInit();
    });
  }
});
